<template>
  <div class="jumbotron">
    <div class="container">
      <h1 class="">{{title}}</h1>
    </div>
  </div>
</template>

<script>
import search from '~/assets/js/search'
export default {
  mixins: [search]
}
</script>



// WEBPACK FOOTER //
// Jumbotron.vue?76c0a4b8